import React from 'react';
import classNames from '../utility/classNames';
import Icon from './Icon';

export default function Tooltip({
  type = '',
  children,
  text,
  heading,
  formula,
  classes,
  offset = '',
  delay = false,
  iconColour = 'text-neutral-600 opacity-[0.8]',
  iconSize = 'text-xl',
  iconMargin = 'mb-[0.23rem]',
}) {
  const className = classNames(
    'relative z-10 text-[11px] font-normal text-black leading-none bg-white shadow-lg rounded-sm border-[1px] border-t-2 border-primary',
    !heading && !formula && 'py-3 px-2',
    classes
  );

  if (type === 'info' && !offset) {
    offset = 'bottom-7 -left-[2.55rem]';
  }

  return (
    <div className="relative group inline ">
      {children}
      {type === 'info' && (
        <Icon
          icon="TbInfoCircle"
          className={classNames(
            'inline tooltip-icon',
            iconMargin,
            iconColour,
            iconSize
          )}
        />
      )}
      <div
        className={classNames(
          'absolute w-56 text-center flex-col z-50 items-center rounded-md whitespace-normal',
          delay
            ? 'opacity-0 group-hover:opacity-100 transition-all duration-100 delay-300'
            : 'hidden group-hover:block',

          offset
        )}
      >
        <div className={className}>
          {!heading && !formula && <span>{text}</span>}
          {/* <div className="w-3 h-3 -mt-2 ml-11 rotate-45 bg-white"></div> */}
          {(formula || heading) && (
            <div>
              {heading && (
                <h4 className="text-base font-medium p-2 border-b shadow-sm">
                  {heading}
                </h4>
              )}
              <div className="p-1 my-3">{text}</div>
              {Array.isArray(formula) && (
                <div className="flex flex-row flex-wrap gap-1 p-2 m-1 justify-center items-center rounded-md border shadow-inner">
                  {formula.map((el, i) => {
                    return i % 2 === 0 ? (
                      <span
                        key={`formula-${i}`}
                        className={classNames(
                          'font-medium',
                          i === 0 && 'text-primary'
                        )}
                      >
                        {el}
                      </span>
                    ) : (
                      <span key={`formula-${i}`}>{el}</span>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
